export default __webpack_public_path__ + "static/media/Startin_ Out Lightly.43f1d3b6.png";